/** @ngInject */
export default function NotificationSystemsController(notificationSystemsService) {
  const vm = this;
  vm.isLoading = false;
  vm.notificationSystems = [];

  vm.init = init;

  init();

  function init() {
    getNotificationSystems();
  }

  function getNotificationSystems() {
    notificationSystemsService.getNotificationSystems().then(res => {
      vm.notificationSystems = res.data.notificationSystems;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/webhooks/notificationSystemsController.js